module.exports = __webpack_public_path__ + "static/media/sign.6b1f57c2.svg";